import React from "react";
import { Link } from "react-router-dom";
import "./Avatar.css";

export type AvatarSize = "xs" | "s" | "m" | "l" | "xl" | "xxl" | "xxxl";

interface AvatarProps {
  image: string;
  to: string;
  size?: AvatarSize;
  title?: string;
  subtitle?: string;
  alt?: string;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  image,
  to,
  size = "m",
  title,
  subtitle,
  alt = "Avatar",
  className = ""
}) => {
  return (
    <Link to={to} className={`avatar-link ${className}`}>
      <img
        src={image}
        alt={alt}
        className={`avatar-img avatar-${size}`}
      />
      {(title || subtitle) && (
        <div className="avatar-details">
          {title && <span className="avatar-title">{title}</span>}
          {subtitle && <span className="avatar-subtitle">{subtitle}</span>}
        </div>
      )}
    </Link>
  );
};

export default Avatar;